import React, { useState } from 'react';

const Checkinpopup3 = (props) => {
    return (
        <>
            <div className="checkinpopup_bg">
                <div className='checkinpopup_content'>
                    <img src="/assets/images/crosspopup.svg" onClick={() => { props.hideSlide() }} className="close_check" alt="" />
                    <div className="checkinpopup_inner">
                        <h5 className='swacg_h'>Steps to enable location</h5>

                        <h4 className="app_head">iOS</h4>
                        <h6 className="app_set">
                            <span className="app_blue">Settings</span> <img src="/assets/images/arrowleft.svg" alt="" />

                            <span className="app_blue">Narendra Modi App</span> <img src="/assets/images/arrowleft.svg" alt="" />

                            <span className="app_blue">Location</span> <img src="/assets/images/arrowleft.svg" alt="" />

                            <span className="app_black">“Ask Next Time or When I Share” or “While Using the App”</span>
                        </h6>

                        <h4 className="app_head">Android</h4>
                        <h6 className="app_set">
                            <span className="app_blue">Settings</span> <img src="/assets/images/arrowleft.svg" alt="" />

                            <span className="app_blue">Location</span> <img src="/assets/images/arrowleft.svg" alt="" />

                            <span className="app_blue">App access to location</span> <img src="/assets/images/arrowleft.svg" alt="" />
                            <span className="app_blue">Narendra Modi App</span> <img src="/assets/images/arrowleft.svg" alt="" />

                            <span className="app_black">“Ask only while using this App”</span>
                        </h6>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Checkinpopup3;